import { useEffect, useRef, type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useAuthStore } from "@/shared/auth/store";
import { ToastProvider } from "@/shared/ui/Toast";
import { ConfirmProvider } from "@/shared/ui/ConfirmDialog";

// eslint-disable-next-line react-refresh/only-export-components -- queryClient переиспользуется вне React-дерева
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

/** При смене субъекта (другой сотрудник вошёл) — весь кэш Query теряет силу (07-admin.md §2 "generation"). */
function GenerationCacheReset() {
  const generation = useAuthStore((s) => s.generation);
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    queryClient.clear();
  }, [generation]);
  return null;
}

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <GenerationCacheReset />
      <ToastProvider>
        <ConfirmProvider>{children}</ConfirmProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
